const AppImages = {
    logo: require("../Images/apparelLogo.svg").default,
    inventory: require("../Images/Inventory.svg").default,
    bill: require("../Images/Bill.svg").default,
    customer: require("../Images/Customer.svg").default,
    report: require("../Images/Report.svg").default,
    apparelLoginBackground: require("../Images/apparelLoginBackground.svg").default,
    bigLogo: require("../Images/largeLogo.svg").default,
    soldIcon: require("../Images/soldIcon.svg").default,
    downloadIcon: require("../Images/downloadIcon.svg").default,
    dateIcon: require("../Images/dateIcon.svg").default,
    stickeringCompleted: require("../Images/stickeringCompleted.svg").default,
    filterIcon: require("../Images/filterIcon.svg").default,
    inventoryBack: require("../Images/inventoryBack.svg").default,
    notFound404: require("../Images/404.png"),
    penimage: require("../Images/penimg.svg").default,
    rupeesimg: require("../Images/rupeesimg.svg").default,
    cyclecount: require("../Images/cyclecountimg.svg").default,
    tickimg: require("../Images/tickimg.svg").default,
    missingimg: require("../Images/missingimg.svg").default,
    datePickerIcon: require("../Images/datePickerIcon.svg").default,
    circletickimg: require("../Images/check_circle.svg").default,
    editIcon: require("../Images/editIcon.svg").default,
    exportLogo: require("../Images/exportLogo.svg").default,
    singleUser: require("../Images/single-user-icon.svg").default,
    category: require("../Images/category.svg").default,
    bannerIcon: require("../Images/bannerIcon.svg").default,
    reportIcon: require("../Images/reportIcon.svg").default,
    customerIcon: require("../Images/customerIcon.svg").default,
    vendorsIcon: require("../Images/vendorsIcon.svg").default,
    dashboardIcon: require("../Images/dashboardIcon.svg").default,
    categoryFilled: require("../Images/categoryFilled.svg").default,
    bannerFilledIcon: require("../Images/bannerFilledIcon.svg").default,
    reportFilledIcon: require("../Images/reportFilledIcon.svg").default,
    customerFilledIcon: require("../Images/customerFilledIcon.svg").default,
    vendorsFilledIcon: require("../Images/vendorsFilledIcon.svg").default,
    orderFilledIcon: require("../Images/orderFilledIcon.svg").default,
    orderIcon: require("../Images/orderIcon.svg").default,
    dashBoardFilledIcon: require("../Images/dashBoardFilledIcon.svg").default,
    editIconImage: require("../Images/editIconImage.svg").default,
    binIcon: require("../Images/binIcon.svg").default,
    imageIcon: require("../Images/imageIcon.svg").default, //delete this image after api bind name -imageIcon
    dress: require("../Images/dress.svg").default,
    bagIcon: require("../Images/bagIcon.svg").default,
    upArrow: require("../Images/upArrow.svg").default,
    inactiveIcon: require("../Images/inactiveIcon.svg").default,
    dropDownIcon: require("../Images/dropDownIcon.svg").default,
    calendarIcon: require("../Images/calendarIcon.svg").default,
    onlineReturnIcon: require('../Images/onlineOrderReturned.svg').default,
    onlineCancelledIcon: require('../Images/onlineOrderCancelled.svg').default,
    onlineOrderIcon: require('../Images/onlineOrderIcon.svg').default,
    printIcon: require("../Images/printing-icon.svg").default
}

export default AppImages;